import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { upsertPaymentInitiate } from '../../../../actions/payments';
import OnlinePaymentModal from './OnlinePaymentModal';
import { currentFlowTypeEnum } from '../constants';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', []);
  const invoiceData = _get(state, 'company.invoiceData', []);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    ...state,
    invoiceData,
    fetchingInvoices:
      _get(state, 'apiState.GET_COMPANY_INVOICES.isFetching', true) &&
      !_get(state, 'apiState.GET_COMPANY_INVOICES.isIdle', false),
    fetchedInvoices: _get(state, 'apiState.GET_COMPANY_INVOICES.success', true),
    selectedWorkspace,
    upsertingPayment:
      _get(state, 'apiState.UPSERT_PAYMENT.isFetching', false) &&
      !_get(state, 'apiState.UPSERT_PAYMENT.isIdle', true),

    upsertPaymentSuccess: _get(state, 'apiState.UPSERT_PAYMENT.success', false),
  };
};

const mapDispatchToProps = dispatch => ({
  upsertPayment: payload => dispatch(upsertPaymentInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnlinePaymentModal);
